import { useState, useCallback, useEffect } from 'react';
import { QueryHookParam, useQueryDummyHook } from '@utils/hook/useQueryHook';
import { teamManagerViewType } from '@models/manager/account/account';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';

import { fetchTeamInfoList, fetchTopInfoQuota } from '@reducers/account/thunks/teamThunk';

import TopInfo from '@components/template/accountSettings/team/topInfo';
import TeamList from '@components/template/accountSettings/team/teamList';
import MemberList from '@components/template/accountSettings/team/memberList';
import CreateTeamPopup from '@components/template/accountSettings/team/createTeamPopup';

const Team = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userInfo } = useSelector(({ auth }: RootState) => auth);
  const { viewState, quotaInfo, isPopupOpen } = useSelector(({ team }: RootState) => team);

  // memberFilterObj state
  const [memberListFilterObj, setMemberListFilterObj] = useState(null);

  // useEffect for request TopInfoQuota && TeamInfoList
  useEffect(() => {
    //@ts-ignore
    dispatch(fetchTopInfoQuota({ ...userInfo }));
    //@ts-ignore
    dispatch(fetchTeamInfoList({ ...userInfo }));
  }, []);

  const memberFilterObjHandler = useCallback((filterObj) => {
    console.log('filterObj: ', filterObj);
    setMemberListFilterObj(filterObj);
  }, []);

  return (
    <>
      {quotaInfo && <TopInfo memberListFilterHandler={memberFilterObjHandler} />}
      {viewState === teamManagerViewType.teamList && <TeamList />}
      {viewState === teamManagerViewType.memberList && <MemberList filterObj={memberListFilterObj} />}
      {isPopupOpen && <CreateTeamPopup />}
    </>
  );
};

export default Team;
